import React from "react";


const WhyZirae = () => {
  return (
    <section className="whyzirae">
      <div className="whyzirae-container">
        {/* Left Image */}
        <div className="whyzirae-image">
          <img
            src="/assets/images/cotton.webp"
            alt="Zirae Chemicals"
          />
        </div>

        {/* Right Content */}
        <div className="whyzirae-content">
          <h2>WHY ZIRAE CHEMICALS</h2>
          <p className="intro">
            Paints aren’t just colors & POP aren’t just designs – They are
            the language of your space, the first impression people feel when
            they walk in. That’s why <span>Zirae stands apart</span>because we bring in
          </p>

          <ul className="whyzirae-list">
            <li>
              <strong>Expert Hands + Lasting Impacts:</strong> With Skilled
              professionals who treat your walls like a canvas, not a contract.
            </li>
            <li>
              <strong>Premium Materials + Precision Artistry:</strong> Every of your
              project are handled to reflects your vision, not a generic template. You can 
              trust us to always deliver more than promised .
            </li>
          </ul>

          <p className="closing">
            With Zirae, you’re not hiring a service – you’re choosing a partner
            who elevates your space & protects your investments.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhyZirae;
